module.exports = __webpack_public_path__ + "img/procon_description.99db4815.jpeg";